import React from "react";
import MUIBox from "@mui/material/Box";
import makeStyles from "@mui/styles/makeStyles";
const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        justifyContent: "space-between",
        gap: theme.spacing(2),
        "& > *": {
            flexBasis: 1,
            flexGrow: 1,
        },
    },
}));
const BoxActions = ({ children }) => {
    const classes = useStyles();
    return React.createElement(MUIBox, { className: classes.root }, children);
};
export default BoxActions;
